// Sigma 3 normally uploads its unchanged arrays from bindProgram on every
// render. Keep both normal and picking buffers resident until processing changes
// them. Rebind pointers each draw; never assume another program's GL state.
export function cachedProgram(Base) {
  return class CachedProgram extends Base {
    process(...args){this.revision=(this.revision||0)+1;return super.process(...args);}
    reallocate(capacity){if(capacity!==this.capacity)this.revision=(this.revision||0)+1;return super.reallocate(capacity);}
    bindProgram(info){
      const {gl}=info;let offset=0;
      this.uploaded ||= new WeakMap();
      const dirty=this.uploaded.get(info)!==this.revision;
      if(this.isInstanced){
        gl.bindBuffer(gl.ARRAY_BUFFER,info.constantBuffer);
        for(const a of this.CONSTANT_ATTRIBUTES)offset+=this.bindAttribute(a,info,offset,false);
        if(dirty)gl.bufferData(gl.ARRAY_BUFFER,this.constantArray,gl.STATIC_DRAW);
        offset=0;
      }
      gl.bindBuffer(gl.ARRAY_BUFFER,info.buffer);
      for(const a of this.ATTRIBUTES)offset+=this.bindAttribute(a,info,offset,this.isInstanced);
      if(dirty){gl.bufferData(gl.ARRAY_BUFFER,this.array,gl.DYNAMIC_DRAW);this.uploaded.set(info,this.revision);}
      gl.bindBuffer(gl.ARRAY_BUFFER,null);
    }
  };
}
